import React, { useState, useEffect } from 'react';
import LandingPage from './landingPage';

const App: React.FC = () => {
  const [showCookies, setShowCookies] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) setShowCookies(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookies(false);
  };

  return (
    <>
      <LandingPage />

      {showCookies && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          padding: '1rem',
          backgroundColor: '#111827',
          color: 'white',
          zIndex: 2000,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
          <p style={{ margin: 0, fontSize: '0.875rem' }}>
            Utilizamos cookies para mejorar tu experiencia. Al continuar, aceptas nuestra política de privacidad.
          </p>
          <button
            onClick={handleAccept}
            style={{
              backgroundColor: '#FBBF24',
              color: '#111827',
              border: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '0.375rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              marginLeft: '1rem',
              marginTop: '0.5rem'
            }}
          >
            Aceptar
          </button>
        </div>
      )}
    </>
  );
};

export default App;
